import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import TenantModel from '../../models/TenantModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';


const TenantView: React.FC = () => {
    const { handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [formData, setFormData] = useState<TenantModel>();

    let idParams: IdParams = useParams();
    let tenantId: number | undefined;
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        tenantId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (tenantId !== undefined) {
            DataService.getById<TenantModel>('api/v1/tenants/', tenantId)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [tenantId]);

    function submit() {
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps } = useValidation(formConfig, formData);

    const { isAuthorizedFor } = useAuth();
    if (tenantId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.ViewTenant)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form title='Tenant' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={3}>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                {formData && (
                    <Container fluid>
                        <Row>
                            {formData.logoUrl && (
                                <Col md='2'>
                                    <img src={formData.logoUrl} style={{ width: '100%' }} />
                                </Col>
                            )}

                            <Col md='9'>
                                <TextboxField {...getFieldProps('name')} />
                                <Field {...getLabelProps('beginDate')}>
                                    <DateControl {...getControlProps('beginDate')} />
                                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                    <DateControl {...getControlProps('endDate')} />
                                </Field>
                            </Col>
                        </Row>
                    </Container>
                )}

            </Form>
        </div>
    );
}
export default TenantView;